export default __webpack_public_path__ + "static/media/wirecast.5382335e.png";